// @ts-strict-ignore
import { FloatingServiceMenu, Footer, Header, Page, PageTransition } from '@components/Page';
import { GigyaScreenSet } from '@components/gigya/GigyaScreenSet';
import { buildLanguageAlternateNavigation } from '@lib/build-language-alternates';
import { getServerSideTranslations } from '@lib/get-server-side-translations';
import { GetStaticProps } from 'next';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { FC } from 'react';
const container = "cmlxa6n";
const Create: FC = () => {
  const {
    t
  } = useTranslation('navigation');
  const {
    locales
  } = useRouter();
  return <Page title={`Account - ${t('account.create.title')}`} languageAlternates={buildLanguageAlternateNavigation(locales, 'account.create.url')}>
      <FloatingServiceMenu />
      <Header initialVariant="absolute" />
      <PageTransition>
        <div className={container}>
          <GigyaScreenSet screenSet="Gassan-RegistrationLogin" startScreen="gigya-register-screen-form-only" />
        </div>
        <Footer />
      </PageTransition>
    </Page>;
};
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await getServerSideTranslations(locale))
    }
  };
};
export default Create;

require("./create.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./create.tsx");